import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogisticsService } from '../../../../logistics/logistics.service';
import { MessageService } from '../../../services/message.service';

@Component({
  standalone: false,
  selector: 'app-transporter-autocomplete',
  templateUrl: './transporter-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss'],
})
export class TransporterAutocompleteComponent implements OnInit {
  @Input() transporter: any;
  items: Array<any> = [];
  searchTerm: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private logisticsService: LogisticsService, private message: MessageService) {}

  ngOnInit(): void {
    this.searchTerm = this.transporter?.name;
  }

  getAllItems(): any {
    this.getListOfTransporters();
  }

  getListOfTransporters(): void {
    this.logisticsService.getTransporters(this.searchTerm).subscribe(
      res => {
        this.items = [];

        res.results.forEach(item => {
          this.items.push(item);
        });

        this.isListVisible = this.items.length > 0 && this.searchTerm.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;
    this.searchTerm = item.name;
  }

  trackByFn(index: number): number {
    return index;
  }
}
